import translate from "../locales";
import { InputGroup } from "../components/form/input-group";
import { TextInput } from "../components/form/text-input";
import { ContinueCard } from "../components/info-sources/source-continue-card";
import { ExercisePage } from "../components/exercise-page";
import clsx from "clsx";
import { useContext } from "react";
import { ClassroomContext } from "../components/classroom.context";

export function ExercisePageTitle1({ onPrevious, onNext }) {
  const { requireFields } = useContext(ClassroomContext);

  return (
    <ExercisePage
      title="exercise.last_1.title"
      description="exercise.last_1.description"
      labelPrevious="exercise.last_1.button-previous"
      onPrevious={onPrevious}
    >
      <title>{translate("exercise.last_1.page-title")}</title>

      <div className={clsx("flex-box", "flex-box_heading")}>
        <InputGroup light>
          <TextInput
            id="title"
            placeholder="exercise.last_1.question_1.a-placeholder"
            maxLength={55}
          />
        </InputGroup>
      </div>

      <div className={clsx("flex-box", "flex-box_heading")}>
        <ContinueCard
          img={
            <svg
              width="52"
              height="52"
              viewBox="0 0 52 52"
              fill="none"
              aria-hidden
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M31.3894 22.8215C31.7951 22.8215 32.1843 22.6603 32.4713 22.3734C32.7582 22.0864 32.9194 21.6972 32.9194 21.2915V20.4398C32.9207 19.9898 33.1 19.5586 33.4182 19.2404C33.7365 18.9221 34.1676 18.7428 34.6177 18.7415H35.2961C36.5584 18.7415 37.7692 18.2403 38.6624 17.3481C39.5555 16.456 40.0581 15.2457 40.0594 13.9831V13.1315C40.0594 12.5848 39.7677 12.0798 39.2944 11.8065C38.8211 11.5331 38.2377 11.5331 37.7644 11.8065C37.2911 12.0798 36.9994 12.5848 36.9994 13.1315V13.9831C36.998 14.4332 36.8188 14.8643 36.5005 15.1826C36.1823 15.5009 35.7511 15.6802 35.301 15.6815H34.6177C33.3561 15.6828 32.1466 16.1845 31.2546 17.0767C30.3624 17.9687 29.8607 19.1783 29.8594 20.4398V21.2915C29.8594 21.6972 30.0206 22.0864 30.3075 22.3734C30.5945 22.6603 30.9836 22.8215 31.3894 22.8215Z"
                fill="#002B6C"
              />
              <path
                d="M17.5177 42.2015C18.3386 42.2023 19.1534 42.0591 19.9247 41.7782L30.5735 37.9073H30.5737C31.7343 37.4991 32.6029 36.5221 32.8723 35.3216C33.1418 34.1212 32.7742 32.8666 31.8996 32.0015L20.6796 20.7815C19.8167 19.9184 18.5728 19.556 17.3813 19.8204C16.1898 20.0851 15.2159 20.9399 14.7994 22.0871L10.903 32.7563C10.385 34.1793 10.3399 35.7314 10.7743 37.1822C11.2086 38.633 12.0995 39.9048 13.3144 40.8092C14.5291 41.7134 16.0032 42.2017 17.5177 42.2014L17.5177 42.2015ZM13.7793 33.8018L17.6501 23.1581V23.1583C17.7091 22.9934 17.8482 22.8702 18.0188 22.8319C18.1897 22.7937 18.3681 22.8455 18.4917 22.9695L29.7117 34.1895C29.8357 34.313 29.8875 34.4915 29.8493 34.6623C29.8109 34.833 29.6878 34.9721 29.5229 35.031L18.8792 38.9019C17.9251 39.2498 16.874 39.2196 15.9416 38.8175C15.0091 38.4154 14.2656 37.672 13.8635 36.7395C13.4614 35.807 13.4312 34.7559 13.7792 33.8018L13.7793 33.8018Z"
                fill="#002B6C"
              />
              <path
                d="M41.0737 33.5315C41.0737 34.3765 40.3887 35.0615 39.5437 35.0615C38.6986 35.0615 38.0137 34.3765 38.0137 33.5315C38.0137 32.6864 38.6986 32.0015 39.5437 32.0015C40.3887 32.0015 41.0737 32.6864 41.0737 33.5315Z"
                fill="#002B6C"
              />
              <path
                d="M40.5686 24.3515C38.3265 24.4074 36.1316 25.0077 34.1732 26.1008C33.704 26.3823 33.4206 26.8927 33.4299 27.4399C33.439 27.9869 33.7394 28.4874 34.2178 28.753C34.6961 29.0186 35.2798 29.0087 35.7491 28.7273C37.2293 27.9148 38.8809 27.4639 40.5686 27.4114C41.1153 27.4114 41.6203 27.1198 41.8936 26.6464C42.167 26.1731 42.167 25.5898 41.8936 25.1164C41.6204 24.6431 41.1154 24.3514 40.5686 24.3514L40.5686 24.3515Z"
                fill="#002B6C"
              />
              <path
                d="M19.6537 13.1366C19.6537 13.9816 18.9688 14.6666 18.1237 14.6666C17.2787 14.6666 16.5938 13.9816 16.5938 13.1366C16.5938 12.2915 17.2787 11.6066 18.1237 11.6066C18.9688 11.6066 19.6537 12.2915 19.6537 13.1366Z"
                fill="#002B6C"
              />
              <path
                d="M25.7789 10.5815C25.3731 10.5815 24.984 10.7427 24.697 11.0296C24.4101 11.3166 24.2489 11.7057 24.2489 12.1115C24.1919 13.7995 23.7432 15.4512 22.9382 16.9361C22.7146 17.2842 22.6413 17.7079 22.7353 18.1108C22.8293 18.5137 23.0824 18.8615 23.4369 19.0747C23.7915 19.2879 24.2173 19.3483 24.6172 19.2422C25.0172 19.1363 25.3572 18.8728 25.5596 18.5121C26.6534 16.5521 27.2537 14.3554 27.3089 12.1116C27.3089 11.7058 27.1477 11.3167 26.8608 11.0297C26.5737 10.7428 26.1846 10.5816 25.7789 10.5816L25.7789 10.5815Z"
                fill="#002B6C"
              />
            </svg>
          }
          title="exercise.last_1.continue-title"
          description="exercise.last_1.continue-description"
          labelNext="exercise.last_1.button-next"
          buttonNextDisabled={!requireFields(["title"])}
          onClick={onNext}
        />
      </div>
    </ExercisePage>
  );
}
